<style scoped>
    @import url("../../../styles/contadorAguaPage/v3/pesquisa.scss");
</style>

<template>
    <div class="box_classes">

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-magnify</v-icon>
            <span class="ml-2">Pesquisa Geral</span>
        </div>

        <div class="label mt-2"><span class="ml-2">Malhas, grupos ou medidores</span></div>

        <div class="painelGeralConsumidor">

            <div class="searchBar mt-1 mb-1">
                <v-autocomplete
                v-model="valueSelected"
                :items="liCurrentExib"
                color="rgb(247,215,46)"
                class="w-100"
                @change="callSearch(valueSelected)"
                ></v-autocomplete>  

                <v-icon @click="callSearch(valueSelected)"
                size="42"
                class="el_icon_search"
                @mouseover="hoverSearch = 'rgb(31,122,177)'"
                @mouseleave="hoverSearch = 'rgb(247,215,46)'"
                :style="{'color': hoverSearch}">mdi-magnify</v-icon>
            </div>
        </div>

        <div class="mb-1 btnResetSearch">
            <v-btn density="compact" size="small" @click="valueSelected = ''">
                <span>Limpar pesquisa</span>
                <v-icon size="16" :style="{'color':'black'}">mdi-trash-can-outline</v-icon>
            </v-btn>
        </div>

        <div class="label mt-2"><span class="ml-2">Resultado</span></div>

        <div class="painelGeralConsumidor">

            <div class="headersClasses" :style="{'border':'1px solid rgba(7,46,79,0.8)'}">
                <div class="hCard">Nome</div>
                <div class="hCard">Hierarquia</div>
            </div>

            <!-- SHOW AFTER SEARCH -->
            <div class="boxLi" v-if="el != null">
                <div 
                class="liClasses" 
                @click="callH(el)" 
                :style="{'background':el.b}"
                @mouseover="el.b = 'rgb(247,215,46)'"
                @mouseleave="el.b = ''"
                >

                    <div class="cCard">{{ el.t }}</div>

                    <div class="liCard">
                        <div v-for="(r,i) in el.li" :key="i" class="elH">
                            <v-icon v-if="i>0" size="16" class="iconH ml-1 mr-1">mdi-arrow-right</v-icon>
                            <div class="nomeH">{{ r }}</div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- NOT FOUND -->
            <div v-if="flagNotFound" class="notFound">
                <v-icon size="42">mdi-emoticon-sad-outline</v-icon>
                <div>NÃO ENCONTRADO</div>
            </div>

        </div>

    </div>
</template>

<script>
export default {

    data() {
        return {
            //
            items:[], // init empty then is it filled by loop on created.
            hoverSearch:'rgb(247,215,46)',
            valueSelected: '',
            el:null,
            flagNotFound:false,

            // Pre init. Montagem da pesquisa por nome
            liCurrentExib:[], // lista para rcv o proc e exib conteúdo
            liCurrentCon:[], // lista para rcv o proc e con a partir do conteúdo
            malhas:[],
            qntMalhas:0,
            grupos:[],
            qntGrupos:0,
            saidas:[],
            qntOUT:0,
            entradas:[],
            qntIN:0,
            qntEventosOUT:0,
            qntEventosIN:0,
            qntEventos:0,
        }
    },

    methods:{
        //
        callSearch(itemSelected) {
            //console.log('from search!')
            //console.log('itemSelected: ',itemSelected)

            // -- Se o nome itemSelected não estiver na lista 
            if (this.liCurrentExib.indexOf(itemSelected) == -1) { 
                //console.log('NOT FOUND')
                this.flagNotFound = true
                this.el = null
                return 
            }
            this.flagNotFound = false
            //if (itemSelected == '') { return }

            const index = this.liCurrentExib.indexOf(itemSelected);
            //console.log('itemSelected index: ',index)

            this.el = {
                'iddEl':index,
                't':this.liCurrentCon[index].nome, // nome do elemento.
                'li':this.liCurrentCon[index].liExib, // lista hierarquia em que o elemento está contido.
                'rota':this.liCurrentCon[index].rota,
                'b':''
            }
            //console.log('this.el: ',this.el)
        },

        callH(elLocal) { 
            //console.log('Rota do elemento: ',elLocal.rota)
            this.$router.push(elLocal.rota)
        },

        init() {
            // processar: obter todos os nomes de tudo?

            this.malhas = this.$store.state.liMalhas // list
            this.qntMalhas = this.malhas.length
            var m = 0
            while (m < this.qntMalhas) {
                //console.log('this.malhas[m].malha: ',this.malhas[m].malha)

                //http://localhost:8080/ca/malhas/0/grupos/0/medidores
                //http://localhost:8080/ca/malhas/0/grupos/0/medidores/entrada/0
                //http://localhost:8080/ca/malhas/0/grupos/0/medidores/saida/0

                this.qntGrupos = this.malhas[m].grupos.length // int
                this.grupos = this.malhas[m].grupos // list
                var c = 0
                while (c < this.qntGrupos) {
                    //console.log('this.grupos[c].grupo: ',this.grupos[c].grupo)

                    this.qntOUT = this.grupos[c].saidas.length // int
                    this.qntIN = this.grupos[c].entradas.length // int
                    this.saidas = this.grupos[c].saidas // list
                    this.entradas = this.grupos[c].entradas // list
                    var vm = 0
                    while (vm < this.qntOUT) {
                        //console.log('this.saidas[vm].nome: ',this.saidas[vm].nome)
                        // -- NOME SAIDA. (se não for um grupo recém criado)
                        if (this.saidas.length > 0) {

                            this.liCurrentExib.push(this.saidas[vm].nome)
                            this.liCurrentCon.push({
                                'nome':this.saidas[vm].nome,
                                'rota':`/ca/malhas/${m}/grupos/${c}/medidores/saida/${vm}`,
                                'liExib':[this.malhas[m].malha, this.grupos[c].grupo, this.saidas[vm].nome] // malha -> grupo -> saida
                            })
                            this.qntEventosOUT = this.saidas[vm].eventos.length
                        }
                        vm++
                    }
                    var vz = 0
                    while (vz < this.qntIN) {
                        //console.log('this.entradas[vz].nome: ',this.entradas[vz].nome)
                        // -- NOME ENTRADA.
                        if (this.entradas.length > 0) {
                            this.liCurrentExib.push(this.entradas[vz].nome)
                            this.liCurrentCon.push({
                                'nome':this.entradas[vz].nome,
                                'rota':`/ca/malhas/${m}/grupos/${c}/medidores/entrada/${vz}`,
                                'liExib':[this.malhas[m].malha, this.grupos[c].grupo, this.entradas[vz].nome] // malha -> grupo -> entrada
                            })
                            this.qntEventosIN = this.entradas[vz].eventos.length
                        }
                        vz++
                    }
                    // -- NOME GRUPO. (se não for uma malha recém criada)
                    if (this.grupos.length > 0) {
                        this.liCurrentExib.push(this.grupos[c].grupo)
                        this.liCurrentCon.push({
                            'nome':this.grupos[c].grupo,
                            'rota':`/ca/malhas/${m}/grupos/${c}/medidores`,
                            'liExib':[this.malhas[m].malha, this.grupos[c].grupo] // malha -> grupo
                        })
                    }
                    c++
                }
                // -- NOME MALHA.
                this.liCurrentExib.push(this.malhas[m].malha)
                this.liCurrentCon.push({
                    'nome':this.malhas[m].malha,
                    'rota':`/ca/malhas/${m}/grupos`,
                    'liExib':[this.malhas[m].malha] // malha (apenas)
                })
                m++
            }
            this.qntEventos = this.qntEventosIN
        },
    },

    created() {
        window.scrollTo(0,0)

        this.init()
    }
}
</script>